import axios from "axios";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
// import Swal from "sweetalert2";
import instance, { BASE_URL } from "../../services/api";
import toast from "react-hot-toast";

export const image_url = "http://127.0.0.1:8000";
const AuthViewController = () => {
  const navigate = useNavigate();

  const login = (requestData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });

    try {
      const response = await axios.post(`${BASE_URL}login/`, requestData);

      const { message, user_id, access, refresh, permissions } = response.data;

      if (!access) {
        throw new Error("Access token missing in response");
      }

      // Decode token to extract user_type or any custom claims
      let decodedToken;
      try {
        decodedToken = jwtDecode(access);
      } catch (decodeError) {
        console.error("Invalid Token:", decodeError);
        throw new Error("Invalid token format, login failed");
      }

      // const user_type = decodedToken?.user_type || "";
      // console.log("user_type",user_type);

      // setAuthToken(access);
      localStorage.setItem("access_token", access);
      localStorage.setItem("refresh_token", refresh);
      localStorage.setItem("user_id", JSON.stringify(user_id));
      localStorage.setItem("user_type", decodedToken?.user_type || "");

      dispatch({
        type: "LOGIN_SUCCESS",
        payload: { access, user_id, refresh, permissions }
      });
      
      dispatch({ type: "LOADING", payload: false });
      toast.success("You are successfully logged in");

      navigate("/");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });

      toast.error(
        error.response?.data?.non_field_errors?.[0] ||
          "Something went wrong. Please try again!"
      );


      dispatch({
        type: "LOGIN_FAILURE",
        payload: {
          error:
            error.response?.data?.non_field_errors?.[0] || error?.response?.data
        }
      });
    }
  };

  const activeAccount =
    ({ uid, token }) =>
    async (dispatch) => {
      dispatch({ type: "LOADING", payload: true });

      try {
        const response = await axios.get(
          `${BASE_URL}activate/${uid}/${token}/`
        );

        const jsonString = JSON.stringify(response.data);
        const data = JSON.parse(jsonString);
        dispatch({ type: "ACCOUNT_ACTIVATION_SUCCESS", payload: data });
        dispatch({ type: "LOADING", payload: false });
      } catch (error) {
        dispatch({ type: "LOADING", payload: false });
        dispatch({
          type: "ACCOUNT_ACTIVATION_FAILURE",
          payload: { error: error }
        });
      }
    };

  const resetPassword = (uid, token, reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await axios.post(
        `${BASE_URL}reset-password/${uid}/${token}/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "PASSWORD_RESET_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
      navigate("/login");
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      dispatch({
        type: "PASSWORD_RESET_FAILURE",
        payload: { error: error }
      });
    }
  };

  const submitOnboardingForm =
    (uid, token, formData, navigate) => async (dispatch) => {
      dispatch({ type: "LOADING", payload: true });

      try {
        const response = await axios.post(
          `${BASE_URL}onboarding-form/${uid}/${token}/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        );

        dispatch({ type: "ADD_FORM_DATA_SUCCESS", payload: response.data });
        dispatch({ type: "LOADING", payload: false });
        navigate("/login");
      } catch (error) {
        dispatch({ type: "LOADING", payload: false });
        dispatch({
          type: "ADD_FORM_DATA_FAILURE",
          payload: { error: error.response?.data || error.message }
        });
      }
    };

  const getUserDetails = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(
        `${BASE_URL}user-profile/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "GET_USER_DETAILS_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      dispatch({
        type: "GET_USER_DETAILS_FAILURE",
        payload: { error: error }
      });
    }
  };

   const getDashboardData = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(
        `${BASE_URL}employee/dashboard/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "GET_DASHBOARD_DATA_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      dispatch({
        type: "GET_DASHBOARD_DATA_FAILURE",
        payload: { error: error }
      });
    }
  };

  const getEmployerDashboardData = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(
        `${BASE_URL}employer/dashboard/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "GET_EMPLOYER_DASHBOARD_DATA_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      dispatch({
        type: "GET_EMPLOYER_DASHBOARD_DATA_FAILURE",
        payload: { error: error }
      });
    }
  };
  
  const getUserPermissions = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(
        `${BASE_URL}user/permissions/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "GET_USER_PERMISSION_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      console.log(
        "Error fetching user permissions:",
        error.data || error.message
      );

      dispatch({ type: "LOADING", payload: false });
      dispatch({
        type: "GET_USER_PERMISSION_FAILURE",
        payload: { error: error }
      });
    }
  };
  const logout = () => (dispatch) => {
    localStorage.clear();
    // setAuthToken(null);
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("user_type");

    dispatch({ type: "LOGOUT" });
    navigate("/login");
  };

  return {
    login,
    logout,
    getUserDetails,
    getDashboardData,
    activeAccount,
    resetPassword,
    submitOnboardingForm,
    getEmployerDashboardData,
    getUserPermissions
  };
};

export default AuthViewController;
